import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoAccidenteModel } from 'src/app/models/tipo-accidente/TipoAccidenteModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoAccidenteService } from 'src/app/services/tipo-accidente/tipo-accidente.service';

@Component({
  templateUrl: './configuracion-tipo-accidente-registrar.component.html',
  styleUrls: ['./configuracion-tipo-accidente-registrar.component.css']
})
export class ConfiguracionTipoAccidenteRegistrarComponent implements OnInit {
  model: ITipoAccidenteModel = new TipoAccidenteModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private gbuService: TipoAccidenteService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.gbuService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El tipo de accidente fue registrado");
            this.router.navigate(['/configuracion', 'tipo-accidentes']);  
          });
        }
      });
    }
  }

}
